const state = {
    plans: null,
    currency: null,
    currencies: null,
    membership: null,
    monthlySubscriptionPrice: null,
    annualSubscriptionPrice: null,
};

const getters = {
    plans: state => state.plans,
    currency: state => state.currency,
    currencies: state => state.currencies,
    membership: state => state.membership,
    monthlySubscriptionPrice: state => state.monthlySubscriptionPrice,
    annualSubscriptionPrice: state => state.annualSubscriptionPrice,
    current: state => {
        if (!state.plans || !state.currency || !state.membership) {
            return null;
        }

        if (!state.plans[state.currency][state.membership]) {
            return state.plans['GBP'][state.membership];
        }

        return state.plans[state.currency][state.membership];
    },
};

const actions = {};

const mutations = {
    all(state, payload) {
        state.plans = payload.plans;
        state.currency = payload.currency;
        state.currencies = payload.currencies;
        state.membership = payload.membership;
        state.monthlySubscriptionPrice = payload.monthlySubscriptionPrice;
        state.annualSubscriptionPrice = payload.annualSubscriptionPrice;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
